import script from "./EditShopBrandsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShopBrandsDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditShopBrandsDialog.vue?vue&type=style&index=0&id=2bfc1f3a&lang=css"
import "./EditShopBrandsDialog.vue?vue&type=style&index=1&id=2bfc1f3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bfc1f3a"]])

export default __exports__